import { render } from "./TablaTotalesTodosCentros.vue?vue&type=template&id=7eb3bb76"
import script from "./TablaTotalesTodosCentros.vue?vue&type=script&lang=js"
export * from "./TablaTotalesTodosCentros.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__